export default __webpack_public_path__ + "static/media/customer-acquistion.699612ac.png";